import http from '@/http'

export const adminGetMediaTOC = async (mediaId) => {
  return http.get(`/admin/medias/${mediaId}/toc`)
}

export const updateMediaTOC = async (mediaId, payload) => {
  return http.put(`/admin/medias/${mediaId}/toc`, payload)
}
